import useRefreshToken from "@/context/UseRefreshToken"
import useAuth from "@/hooks/useAuth"
import Spinner from "@/pages/spinnner/Spinner"
import { useEffect, useState } from "react"
import { Outlet } from "react-router-dom"

const PersistLogin = () => {
    const [isLoading, setIsLoading] = useState(true)
    const refresh = useRefreshToken()
    const { auth, persist } = useAuth()

    useEffect(() => {
        let isMounted = true

        const verifyRefreshToken = async () => {
            try {
                await refresh();
            } catch (err) {
                console.error(err);
            } finally {
                if (isMounted) {
                    setIsLoading(false);
                }
            }
        }


        if (!auth?.accessToken && persist) {
            verifyRefreshToken();
        } else {
            setIsLoading(false);
        }

        return () => {
            isMounted = false
        }
    }, [auth?.accessToken, persist, refresh])



    return (
        <>
            {!persist
                ? <Outlet />
                : isLoading
                    ? <Spinner />
                    : <Outlet />
            }
        </>
    )
}
export default PersistLogin